import React, { useState } from 'react';
import SEO from '../SEO';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import './ServicePages.css';

const ParkinsonsCare = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Specialized care in familiar home environment',
    'Reduced stress and anxiety for patients',
    'Personalized treatment plans',
    'Improved quality of life',
    'Support for family caregivers',
    'Consistent monitoring of symptoms and medication'
  ];

  const services = [
    {
      name: 'Medication Management',
      description: 'Proper administration and monitoring of Parkinson\'s medications to maintain optimal symptom control.'
    },
    {
      name: 'Physical Therapy',
      description: 'Specialized exercises to improve mobility, balance, and reduce fall risk.'
    },
    {
      name: 'Daily Living Assistance',
      description: 'Help with activities of daily living affected by motor symptoms.'
    },
    {
      name: 'Cognitive Support',
      description: 'Activities and strategies to support cognitive function and mental health.'
    }
  ];

  return (
    <div className="service-page parkinsons-page">
      <SEO 
        title="Parkinson's Care Services in Bangalore"
        description="Specialized Parkinson's care services in Bangalore. Expert home care for Parkinson's patients including medication management, physical therapy, and daily living support."
        keywords="Parkinson's care Bangalore, Parkinson's patient care, neurological care at home, elderly care Parkinson's, home care for Parkinson's"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Parkinson's Care Services</h1>
                <p>Specialized care and support for individuals living with Parkinson's disease</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/parkison-care.jpg" alt="Parkinson's Care Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Specialized Parkinson's Disease Care</h2>
              <p>
                Our Parkinson's care services provide specialized support for individuals living with Parkinson's disease. 
                We understand the unique challenges that come with this progressive neurological condition and offer 
                comprehensive care designed to improve quality of life and maintain independence.
              </p>
              <p>
                Our team of healthcare professionals is specially trained in Parkinson's care, understanding the 
                complexities of motor symptoms, medication management, and the emotional aspects of living with 
                a chronic condition. We work closely with your neurologist and healthcare team to ensure 
                coordinated and effective care.
              </p>
              
              <h3>Our Parkinson's Care Services</h3>
              <Row className="treatment-cards">
                {services.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">Comprehensive Parkinson's Support</h3>
              
            </div>
            <ul className="service-list">
                <li>Medication administration on strict schedules</li>
                <li>Movement exercises and physical therapy</li>
                <li>Fall prevention strategies</li>
                <li>Speech therapy support</li>
                <li>Nutritional guidance</li>
                <li>Assistance with daily activities</li>
                <li>Emotional support and counseling</li>
                <li>Regular assessment and symptom monitoring</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Specialized Care</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Request Parkinson's Care
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Parkinson's Care?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Specialists trained in Parkinson's disease care</li>
                    <li>Personalized care plans based on disease stage</li>
                    <li>Coordination with neurologists and specialists</li>
                    <li>Focus on maintaining independence</li>
                    <li>Support for both patients and family caregivers</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need Specialized Parkinson's Support?</h3>
              <p>Our trained care team is ready to provide the specialized care needed for Parkinson's disease management.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule a Consultation
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Parkinson's Care"
      />
    </div>
  );
};

export default ParkinsonsCare;
